import * as React from 'react';

const WINDOW_EDGE_SPACING = 16;
const SMALLEST_HEIGHT = 480;

export type WindowFillingArea = {
    marginLeft: number;
    width: number;
    height: number;
};

export function useWindowFillingArea(isEnabled: boolean) {
    let anchorRef = React.useRef<HTMLDivElement>(null);
    let [area, setArea] = React.useState<WindowFillingArea | null>(null);

    React.useLayoutEffect(() => {
        function measure() {
            let anchor = anchorRef.current;
            let windowWidth = document.documentElement.clientWidth;
            if (!isEnabled || !anchor || windowWidth === 0) {
                setArea(null);
                return;
            }

            let { left, top } = anchor.getBoundingClientRect();
            setArea({
                marginLeft: WINDOW_EDGE_SPACING - left,
                width: windowWidth - 2 * WINDOW_EDGE_SPACING,
                height: Math.max(SMALLEST_HEIGHT, window.innerHeight - (top + window.scrollY))
            });
        }

        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [isEnabled]);

    return { anchorRef, area };
}
